/**
 * 菜单数据服务
 */
import axios from '../../utils/ajax';
import Constants from '../../utils/constants';
import Global from '../../utils/global';
export const menuApi = (params) => {
	return new Promise((resolve, reject) => {
    if(Global.isStaticMenu()){
      let result = Global.getMenu();
      if(params && params.noCache){
        //for get function
      } else {
        Global.setMenuList(result);
      }
      resolve(result);

      // 如果开启了前端二次鉴权，加载所有菜单数据
      if (Global.getCustomConfig()['KIAF_FRONT_SECONDARY_AUTHENTICATION'] == 'Y') {
        // 处理当前用户的菜单信息，提取菜单中的路由信息
        let routes = getRoutesFromMenu(result);
        handleRoutes(routes);
      }
    } else {
      let url = Global.getCustomApi(Constants.CUSTOM_API_KEY_GET_MENU) || (Global.getBaseUrl() + '/resource/resources_tree_me?sorts[0].name=sortIndex&sorts[0].order=ASC');
      axios.ajax(url, 'get', params).then(ret => {
        let result = [];
        console.log(ret, 'ret');
        if(Array.isArray(ret)){
          ret.forEach(item => {
            if (item.sign == Global.getMenuSign()) {
              if(Array.isArray(item.children)){
                console.log(item.children, '用户权限的菜单资源');
                result = item.children;
              }
            }
          });
          if(result.length <= 0 && ret.length > 0 && Global.getMenuType()){ // not found
            ret.forEach(item => {
              if (item.type == Global.getMenuType()) {
                result.push(item);
              }
            });
          }
        }
                
        // 处理当前用户的菜单信息，提取菜单中的路由信息
        let routes = getRoutesFromMenu(result);
        console.log('menu -------- routes = ', routes);

        result = Global.getMenu().concat(result);
        if(params && params.noCache){
          //for get function
        } else {
          Global.setMenuList(result);
        }
        resolve(result);

        // 如果开启了前端二次鉴权，加载所有菜单数据
        if (Global.getCustomConfig()['KIAF_FRONT_SECONDARY_AUTHENTICATION'] == 'Y') {
          handleRoutes(routes);
        }        
      }).catch((err) => {
        console.error('menuApi err', err);
        resolve(Global.getMenu());
      });
    }
	});
};

// 处理禁止访问页面的路由
// routes 是当前用户菜单中所有页面的路由信息
function handleRoutes(routes) {
  allMenuApi().then(allMenu => {
    // 获取全部菜单中的路由信息
    let allRoutes = getRoutesFromMenu(allMenu);
    // 从全部路由中剔除当前用户已被分配页面的路由，剩下的就是当前用户没有权限访问的页面；
    let forbiddenRoutes = allRoutes.filter(route => !routes.includes(route));
    console.log('forbiddenRoutes --- ', forbiddenRoutes);
    // 保存路由信息
    Global.setForbiddenRoutes(forbiddenRoutes);
  });
}

// 加载当前系统全部菜单数据
export const allMenuApi = function (params) {
  return new Promise((resolve, reject) => {
    let url = Global.getBaseUrl() + '/rbacResource/adminResource';
    axios.ajax(url, 'get', params).then(ret => {
      console.log('allMenuApi ----- ', ret);
      let result = [];
      if(Array.isArray(ret)) {
        ret.forEach(item => {
          if (item.sign == Global.getMenuSign()) {
            if(Array.isArray(item.children)){
              result = item.children;
            }
          }
        });
        if(result.length <= 0 && ret.length > 0 && Global.getMenuType()){ // not found
          ret.forEach(item => {
            if (item.type == Global.getMenuType()) {
              result.push(item);
            }
          });
        }
      }
      resolve(result);
    }).catch((err) => {
      console.error('allMenuApi err', err);
      resolve([]);
    });
  });
};

// 将菜单中的页面地址全部提取出来
function getRoutesFromMenu(menu) {
  let result = [];
  for (let i = 0, length = menu.length; i < length; i++) {
    let menuItem = menu[i];
    if (menuItem.children && menuItem.children.length > 0) {
      result.push(...getRoutesFromMenu(menuItem.children));
    } else if (menuItem.url && !menuItem.url.startsWith('http://') && !menuItem.url.startsWith('https://') && !menuItem.url.startsWith('//')) {
      result.push(menuItem.url);
    }
  }
  return result;
}